"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayName = void 0;
const lodash_1 = require("lodash");
const getDisplayName = (data, firstNameOnly = false) => {
    let displayName = "";
    if (!data)
        return displayName;
    const firstName = data.firstName?.trim();
    if (!(0, lodash_1.isEmpty)(firstName)) {
        displayName = firstName;
    }
    if (!firstNameOnly) {
        const lastName = data.lastName?.trim();
        if (!(0, lodash_1.isEmpty)(lastName)) {
            if (!(0, lodash_1.isEmpty)(displayName)) {
                displayName += " " + lastName;
            }
            else {
                displayName = lastName;
            }
        }
    }
    if ((0, lodash_1.isEmpty)(displayName)) {
        const companyName = data.companyName?.trim();
        const email = data.email?.trim();
        const phoneNumber = data.phoneNumber?.trim();
        if (!(0, lodash_1.isEmpty)(companyName)) {
            displayName = companyName;
        }
        else if (!(0, lodash_1.isEmpty)(email)) {
            displayName = email;
        }
        else if (!(0, lodash_1.isEmpty)(phoneNumber)) {
            displayName = phoneNumber;
        }
    }
    return displayName;
};
exports.getDisplayName = getDisplayName;
//# sourceMappingURL=display-name.js.map